import { notification } from "antd";
import type { ArgsProps } from "antd/es/notification/interface";

export type AppNotificationOptions = Omit<ArgsProps, "placement">;

const withStandardPlacement = (options: AppNotificationOptions) => ({
  ...options,
  placement: "topRight" as const,
});

export const appNotification = {
  success: (options: AppNotificationOptions) =>
    notification.success(withStandardPlacement(options)),
  error: (options: AppNotificationOptions) =>
    notification.error(withStandardPlacement(options)),
  warning: (options: AppNotificationOptions) =>
    notification.warning(withStandardPlacement(options)),
  info: (options: AppNotificationOptions) =>
    notification.info(withStandardPlacement(options)),
};
